import { SearchResultList } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultList";
import { SearchResultMenuContent } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultMenuContent";
import { toSearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-menu.utils";
import { SEARCH_QUERY_MIN_CHARS } from "@/components/layout/Navbar/ApplicationSearch/application-search.consts";
import {
    SearchCategory,
    SearchResultItem,
    SearchResults,
} from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { Loader } from "@/components/ui/Loader";

type Props = {
    data: SearchResults;
    query: string;
    category: SearchCategory;
    isLoading: boolean;
    onClick: (item: SearchResultItem) => void;
};

const SearchResultMenu = (props: Props) => {
    const items = toSearchResultItem(props.category, props.data);
    const isQueryTooShort = props.query.length < SEARCH_QUERY_MIN_CHARS;

    return (
        <>
            {isQueryTooShort ? (
                <SearchResultMenuContent>
                    <span>Please enter at least {SEARCH_QUERY_MIN_CHARS} characters to display results</span>
                </SearchResultMenuContent>
            ) : props.isLoading ? (
                <SearchResultMenuContent>
                    <Loader size="24px" />
                </SearchResultMenuContent>
            ) : items.length === 0 ? (
                <SearchResultMenuContent>
                    <span>
                        No matching results for <b>{props.query}</b> were found
                    </span>
                </SearchResultMenuContent>
            ) : (
                <SearchResultList data={items} onClick={props.onClick} />
            )}
        </>
    );
};

export { SearchResultMenu };
